<template>
	<div class="display-flex flex-row flex-align-center">
		<PreviouslySelectedFavoriteApps v-if="!hidePrevious" />
		<v-menu
			:width="480"
			rounded="lg"
			:height="460"
			v-model="showMenu"
			origin="center bottom"
			transition="slide-y-transition"
			:close-on-content-click="false"
			:nudge-right="nudgeRight || 8"
			:nudge-bottom="nudgeBottom || 48"
			content-class="select-favorite-apps-menu"
		>
			<template v-slot:activator="{ on, attrs, value }">
				<div v-on="on" v-bind="attrs">
					<slot v-bind:value="value" name="activator">
						<AnemicButton tile class="add-button pa-0 ml-2" :class="{ selected: value }">
							<SIcon class="plus" name="plus-new-apps" width="11" height="13" />
						</AnemicButton>
					</slot>
				</div>
			</template>
			<SelectFavoriteAppsMenuContent />
		</v-menu>
	</div>
</template>
<script>
import SelectFavoriteAppsMenuContent from '@/components/SelectFavoriteApps/SelectFavoriteAppsMenuContent.vue';
import PreviouslySelectedFavoriteApps from '@/components/SelectFavoriteApps/PreviouslySelectedFavoriteApps.vue';
export default {
	name: 'SelectFavoriteAppsMenu',
	props: {
		nudgeRight: { type: Number },
		nudgeBottom: { type: Number },
		hidePrevious: { type: Boolean },
	},
	components: {
		SelectFavoriteAppsMenuContent,
		PreviouslySelectedFavoriteApps,
	},
	methods: {
		open() {
			// Triggered from parent
			this.showMenu = true;
		},
	},
	data() {
		return {
			showMenu: false,
		};
	},
};
</script>
<style lang="scss" scoped>
.select-favorite-apps-menu {
	border-radius: 10px !important;
	border: 1px solid #abb2bd6e !important;
	background-color: var(--bg-color) !important;
	box-shadow: 0px 1px 2px #80899c4d !important;
}
.add-button {
	width: 45px !important;
	height: 45px !important;
	border-radius: 10px !important;
	background: #efeefb !important;
	border: 1px dashed #605ed9 !important;
	&.selected {
		border-style: solid !important;
	}
}
.plus {
	margin-right: 2px;
}
</style>
